export default "__VITE_ASSET__BT97g$1j__"